<template>
  <div
    ref="wholeContainer"
    class="container w-full min-w-full h-full"
    :class="{ dark: isDarkModeEnabled }"
  >
    <div
      class="fixed w-full min-w-full h-full transition-all duration-300 bg-white dark:bg-blueDianne text-black dark:text-white"
    >
      &nbsp;
    </div>
    <div class="w-full overflow-y-auto">
      <div id="google_onetap"></div>
      <cookies />
      <navbar />
      <main>
        <section class="relative w-full">
          <router-view />
          <dark-mode-toggle
            :is-dark-mode-enabled="isDarkModeEnabled"
            class="fixed bottom-3 right-3"
            @toggle-dark-mode="toggleDarkMode()"
          />
          <div
            v-if="$route.params.researchCompassId && !showFooter"
            class="absolute bottom-0 w-full pointer-events-none z-10"
          >
            <div class="container max-w-[1440px] mx-auto relative h-full">
              <div
                class="absolute left-0 bottom-0 rounded-t-lg h-[30px] text-xs flex items-center justify-center w-[280px] uppercase cursor-pointer pointer-events-auto bg-white dark:bg-blueDianne"
                @click="toggleFooter()"
              >
                About&nbsp;Research&nbsp;Compass&nbsp;&nbsp;<i
                  class="fa-solid fa-arrow-down"
                ></i>
              </div>
            </div>
          </div>
          <marketing-footer
            v-if="!$route.params.researchCompassId || showFooter"
          />
        </section>
      </main>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { nextTick } from "vue";
import { utils, components } from "common-frontend";
import Navbar from "../components/Navbars/Navbar.vue";
import MarketingFooter from "../components/Footers/Footer.vue";
import Cookies from "../components/Cookies.vue";

const { DarkModeToggle } = components.ResearchCompass;

const { keysToCamel } = utils;

export default {
  components: {
    Navbar,
    MarketingFooter,
    Cookies,
    DarkModeToggle,
  },
  data() {
    return {
      showFooter: false,
      isDarkModeEnabled: import.meta.env.SSR
        ? false
        : window.matchMedia("(prefers-color-scheme: dark)").matches,
    };
  },
  mounted() {
    if (!import.meta.env.SSR) {
      this.$api
        .attemptAccessTokenRefresh(true)
        .catch(() => {})
        .finally(() => {
          setTimeout(() => this.setUpGoogleAuth(), 500);
        });
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY === 0) {
        this.showFooter = false;
      }
    },
    toggleDarkMode() {
      this.isDarkModeEnabled = !this.isDarkModeEnabled;
    },
    toggleFooter() {
      this.showFooter = !this.showFooter;
      if (this.showFooter) {
        nextTick(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
          });
        });
      }
    },
    handleGoogleClientId(data) {
      const payload = {
        id_token: data.credential,
        personType: this.personType,
        referralCode: this.referralCode,
      };
      this.$store.commit("setIsCheckingAuth", true);
      return axios
        .post(
          `${import.meta.env.VITE_API_BASE_URL}/consume-google-token/`,
          payload,
          { withCredentials: true },
        )
        .then((res) => {
          const data2 = keysToCamel(res.data);
          this.$store.dispatch("loginViaToken", {
            hashedId: data2.hashedId,
            token: data2.passwordResetCode,
          });
        });
    },
    setUpGoogleAuth() {
      if (window.google) {
        const self = this;
        window.handleGoogleClientId = (data) => {
          self.handleGoogleClientId(data);
        };
        window.google.accounts.id.initialize({
          client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
          callback: window.handleGoogleClientId,
          auto_select: true,
          cancel_on_tap_outside: true,
          context: "use",
          itp_support: true,
          use_fedcm_for_prompt: true,
        });
        if (!this.$store.getters.isPersonLoggedIn) {
          window.google.accounts.id.prompt();
        }
      }
    },
  },
};
</script>
